import { EffectLog } from "./EffectLog";

export class AutomationEffect {
  constructor({
    id = Number.NaN,
    action = "",
    actionExtra = {},
    event = "",
    eventExtra = {},
    nextLaunch = {},
    dateCreated = null,
    activateIn = null,
    label = null,
    unique = false,
    logs = [],
    statuses = [],
    actionConfig = {},
    notifyImmediately = false,
    notifyImmediatelyMessage = "",
  } = {}) {
    this.id = id;
    this.action = action;
    this.actionExtra = actionExtra;
    this.event = event;
    this.eventExtra = eventExtra;
    this.nextLaunch = nextLaunch;
    this.activateIn = activateIn;
    this.label = label;
    this.unique = unique;
    this.dateCreated = dateCreated ? new Date(dateCreated) : new Date();
    this.logs = logs ? logs.map((log) => new EffectLog(log)) : [];
    this.statuses = statuses;
    this.actionConfig = actionConfig;
    this.notifyImmediately = notifyImmediately;
    this.notifyImmediatelyMessage = notifyImmediatelyMessage;
  }

  get effectLabel() {
    return `automation.effect.${this.action.toLocaleLowerCase()}`;
  }

  get effectExtraLabel() {
    if (this.actionExtra?.name) return this.actionExtra.name;
    else if (this.actionExtra?.title) return this.actionExtra.title;
    else if (this.actionExtra?.email) return this.actionExtra.email;

    return "";
  }

  get eventLabel() {
    return `automation.event.${this.event.toLocaleLowerCase()}`;
  }

  get eventExtratLabel() {
    if (this.activateIn || this.activateIn == 0) return this.activateIn;
    return this.eventExtra.name ? this.eventExtra.name : this.eventExtra.title;
  }

  get statusesLabel() {
    if (!this.statuses?.length) return "-";
    return this.statuses.map((s) => s.name).join(", ");
  }

  get xmlPattern() {
    if (!this.actionConfig?.xmlPattern) return "";
    return this.actionConfig.xmlPattern;
  }
}

export class AutomationEffectGroup {
  constructor({ groupAction = "", items = [] } = {}) {
    this.groupAction = groupAction;
    this.items = items ? items.map((item) => new AutomationEffect(item)) : [];
  }

  get effectLabel() {
    return `automation.effect.${this.groupAction.toLocaleLowerCase()}`;
  }

  get isManyItems() {
    return this.items.length > 1;
  }
}
